<!-- Truncated display-->
<div class="highlighted-topline highlighted-topline--email"
     *ngIf="truncate">
  <a *ngIf="topline?.appliedToplineValue && !isDoNotContact()"
     style="text-overflow:ellipsis"
     href="mailto:{{topline.appliedToplineValue.email}}"
     class="link link--noline color--gray--005 txt-fw-500">
    {{topline.appliedToplineValue.email}}
  </a>
  <span *ngIf="topline?.appliedToplineValue && isDoNotContact()"
        style="text-overflow:ellipsis"
        class="color--gray--007 txt-fw-500">
    {{topline.appliedToplineValue.email}}
  </span>
  <i class="fas fa-ban color--red ml-0025"
     *ngIf="isDoNotContact()"
     [matTooltip]="'Do not contact'"
     [matTooltipPosition]="'left'"></i>
  <i class="far fa-check pair__verified ml-0025"
     *ngIf="topline.appliedToplineValue?.subscribed"
     [matTooltip]="'Confirmed'"></i>
  <i class="far fa-bell-on pair__verified ml-0025"
     *ngIf="topline.appliedToplineValue?.subscribed"
     [matTooltip]="'Subscribed'"></i>
</div>

<ng-container *ngIf="!truncate">
  <div class="toplines__pair toplines__pair--email col__ flexAlign--baseline"
       [ngClass]="{'toplines__pair--empty':!topline?.appliedToplineValue}">
    <div class="pair__icon">
      <i class="fal fa-fw fa-envelope"
         matTooltip="Email"></i>
    </div>

    <div class="pair__content truncate">
      <span *ngIf="topline?.appliedToplineValue"
            class="pair__label">Email</span>

      <span *ngIf="!topline?.appliedToplineValue"
            (click)="onAddClicked()"
            class="pair__link link link--noline"
            data-test-id="toplineAddEmailLink">Add
        Email</span>

      <a *ngIf="topline?.appliedToplineValue && !isDoNotContact() && !isBad()"
         href="mailto:{{topline.appliedToplineValue.email}}"
         data-test-id="toplineEmail"
         class="pair__link link link--noline link--black">{{topline.appliedToplineValue.email}}
        <i class="far fa-check pair__verified ml-0025"
           *ngIf="topline.appliedToplineValue?.status === 'verified'"
           [matTooltip]="'Confirmed'"
           [matTooltipPosition]="'left'"></i>
        <i class="far fa-bell-on pair__verified ml-0050"
           *ngIf="topline.appliedToplineValue?.subscribed"
           [matTooltip]="'Subscribed'"
           [matTooltipPosition]="'left'"></i>
      </a>
      <span *ngIf="topline?.appliedToplineValue && isDoNotContact() && !isBad()"
            data-test-id="toplineEmail"
            class="pair__link color--gray--007">
        {{topline.appliedToplineValue.email}}

        <i class="far fa-check pair__verified ml-0050"
           *ngIf="topline.appliedToplineValue?.status === 'verified'"
           [matTooltip]="'Confirmed'"
           [matTooltipPosition]="'left'"></i>
        <i class="far fa-bell-on pair__verified ml-0050"
           *ngIf="topline.appliedToplineValue?.subscribed"
           [matTooltip]="'Subscribed'"
           [matTooltipPosition]="'left'"></i>
      </span>

      <span *ngIf="topline?.appliedToplineValue && !isDoNotContact() && isBad()"
            data-test-id="toplineEmail"
            class="pair__link color--gray--007">
        {{topline.appliedToplineValue.email}}

         <i class="far fa-times-circle pair__red ml-0050"
           *ngIf="topline.appliedToplineValue?.status === 'bad'"
           [matTooltip]="'Marked as Bad'"
           [matTooltipPosition]="'left'"></i>
      </span>

      <span *ngIf="topline?.appliedToplineValue && isDoNotContact() && isBad()"
            data-test-id="toplineEmail"
            class="pair__link color--gray--007">
        {{topline.appliedToplineValue.email}}

        <i class="far fa-check pair__verified ml-0050"
           *ngIf="topline.appliedToplineValue?.status === 'verified'"
           [matTooltip]="'Confirmed'"
           [matTooltipPosition]="'left'"></i>
        <i class="far fa-bell-on pair__verified ml-0050"
           *ngIf="topline.appliedToplineValue?.subscribed"
           [matTooltip]="'Subscribed'"
           [matTooltipPosition]="'left'"></i>
           <i class="far fa-times-circle pair__red ml-0050"
           *ngIf="topline.appliedToplineValue?.status === 'bad'"
           [matTooltip]="'Marked as Bad'"
           [matTooltipPosition]="'left'"></i>
      </span>

    </div>
  </div>
</ng-container>
